import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';

const firebaseConfig = {
  apiKey: "AIzaSyABljTnXc7n7vNXXrbiu1RmdPutx6TDF58",
  authDomain: "contenta-marketing.firebaseapp.com",
  projectId: "contenta-marketing",
  storageBucket: "contenta-marketing.firebasestorage.app",
  messagingSenderId: "838821394850",
  appId: "1:838821394850:web:cff500a4065af113099afb"
};

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
